export const rolesKeys = {
    allRoles: (params?: string) => ['roles', params] as const,
    roleById: (roleId: string | number) => ['roles', 'roleById', roleId] as const,
    modulesWithFeatures: () => ['roles', 'modulesFeatures'] as const,
    permissions: () => ['roles', 'permissions'] as const,
} as const
